import React from 'react'
import SearchHotelInput from '../../components/SearchHotelInput'

export default function HotelInput() {
  return (
    <SearchHotelInput/>
  )
}
